<template>
  <svg
    class="custom-icon"
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.19483 15.7696C5.12131 18.7435 9.87876 18.7435 12.8052 15.7696C15.7316 12.7956 15.7316 7.96103 12.8052 4.98717C9.87869 2.01331 5.12124 2.01324 2.19483 4.98717C-0.731577 7.9611 -0.731645 12.7804 2.19483 15.7696ZM3.26036 6.05457C5.60156 3.67541 9.39858 3.67541 11.7545 6.05457C14.0957 8.43373 14.0957 12.2923 11.7545 14.6865C9.41333 17.0656 5.61631 17.0656 3.26036 14.6865C0.919164 12.3073 0.919164 8.43338 3.26036 6.05457Z"
      fill="rgb(var(--v-theme-primary))"
    />
    <path
      d="M7.50772 14.9458C9.99899 14.9458 12.01 12.9022 12.01 10.3705C12.01 7.83885 9.99899 5.79521 7.50772 5.79521V10.3705H3.00542C3.00542 12.9022 5.01645 14.9458 7.50772 14.9458Z"
      fill="rgb(var(--v-theme-primary))"
    />
    <path d="M5.25674 0H9.75904V1.5251H5.25674V0Z" fill="rgb(var(--v-theme-primary))" />
  </svg>
</template>
